import { createPrefetchApi } from '@RootCommon/api/apiPrefetcher'
import { getI18nWebParamsApi } from './i18nApi'
import { getAccountShopListApi, getShowImMsgBoxApi } from './shopInfoApi'
import { getRbacAuthResourceApi } from './account'

const CACHE_KEYS = {
  getAccountShopListPApi: Symbol('getAccountShopListPApi'),
  getI18nWebParamsPApi: Symbol('getI18nWebParamsPApi'), // 唯一标识符
  getRbacAuthResourceApi: Symbol('getRbacAuthResourceApi'), // 唯一标识符
  getShowImMsgBoxApi: Symbol('getShowImMsgBoxApi'), // 唯一标识符
}

// 获取账号下门店列表预请求
export async function getAccountShopListPApi (params) {
  return createPrefetchApi(CACHE_KEYS.getAccountShopListPApi, getAccountShopListApi, 4 * 1000)(params)
}

// 获取i18n语言信息预请求
export async function getI18nWebParamsPApi (params?) {
  return createPrefetchApi(CACHE_KEYS.getI18nWebParamsPApi, getI18nWebParamsApi, 4 * 1000)(params)
}

// 获取i18n语言信息预请求
export async function getRbacAuthResourcePApi (params?) {
  return createPrefetchApi(CACHE_KEYS.getRbacAuthResourceApi, getRbacAuthResourceApi, 4 * 1000)(params)
}

// 获取i18n语言信息预请求
export async function getShowImMsgBoxPApi (params?) {
  return createPrefetchApi(CACHE_KEYS.getShowImMsgBoxApi, getShowImMsgBoxApi, 10 * 1000)(params)
}
